import { styled } from '@mui/material';

import { fontFamily, fontWeight } from '@/styles/constants/fonts';

export const IdmStyles = styled('div')`
  * {
    font-family: ${fontFamily.primary};
  }
  .fontMedium {
    font-weight: ${fontWeight.medium};
  }

  .idmCard {
    border-radius: 16px;
    background-color: ${({ theme }) => theme.palette.primaries[700]};
  }
  .idmCardWhite {
    box-shadow: none;
    border-radius: 16px;
    border: 1px solid ${({ theme }) => theme.palette.grey[300]};
    background-color: ${({ theme }) => theme.palette.common.white};
  }
  .idmButton {
    border-radius: 16px;
    border: 1px solid ${({ theme }) => theme.palette.grey[500]};
    color: ${({ theme }) => theme.palette.common.white};
    background-color: ${({ theme }) => theme.palette.primaries[700]};
    &:hover {
      background-color: ${({ theme }) =>
        theme.palette.primaries[800]} !important;
    }
  }
  .idmPrimaryButton {
    border-radius: 16px;
    border: 1px solid ${({ theme }) => theme.palette.primaries[500]};
    color: ${({ theme }) => theme.palette.common.white};
    background-color: ${({ theme }) => theme.palette.primaries[500]};
    &:hover {
      background-color: ${({ theme }) =>
        theme.palette.primaries[400]} !important;
    }
  }
  .idmSecondaryButton {
    border-radius: 16px;
    border: 1px solid ${({ theme }) => theme.palette.grey[300]};
    color: ${({ theme }) => theme.palette.primaries[1000]};
    background-color: ${({ theme }) => theme.palette.common.white};
    &:hover {
      background-color: ${({ theme }) => theme.palette.grey[100]};
    }
  }

  .containerFullWidth {
    width: 100%;
  }

  .loadingOverlay__progressBackground {
    background: ${({ theme }) => theme.palette.primaries[900]};
  }
  .loadingOverlay__progressBar {
    span {
      background-color: ${({ theme }) => theme.palette.primaries[400]};
    }
  }

  .successButtonsRow {
    flex-direction: row-reverse;
    gap: ${({ theme }) => theme.spacing(2)};
  }

  .idCapture__container {
    width: 100%;
  }

  .uploadOrCaptureScreen {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: row;
    gap: ${({ theme }) => theme.spacing(2)};
  }
  .uploadOrCaptureScreen__captureWithCameraButton {
    svg {
      display: none;
    }
  }
  .uploadOrCaptureScreen__captureWithCameraIcon {
    width: 80px;
    path,
    circle {
      stroke: ${({ theme }) => theme.palette.common.white};
      stroke-width: 2px;
    }
  }
  .uploadOrCaptureScreen__uploadFromStorageButton {
    svg {
      display: none;
    }
  }
  .uploadOrCaptureScreen__uploadFromStorageIcon {
    width: 50px;
    path {
      stroke: ${({ theme }) => theme.palette.common.white};
      stroke-width: 2px;
    }
  }
  .uploadOrCaptureScreen__separator {
    display: none;
  }
  .uploadOrCaptureScreen__selectIdTypeModal {
    background-color: rgba(199, 199, 199, 0.7);
    backdrop-filter: blur(4px);
    > div {
      padding: ${({ theme }) => theme.spacing(4)};
      display: flex;
      flex-direction: column;
      gap: ${({ theme }) => theme.spacing(2)};
    }
  }
  .uploadOrCaptureScreen__selectIdTypeHeading {
    display: none;
  }
  .uploadOrCaptureScreen__selectPassportTypeIcon {
    path,
    circle,
    ellipse,
    rect {
      stroke: ${({ theme }) => theme.palette.common.white};
      stroke-width: 2px;
    }
    rect {
      fill: none;
    }
  }
  .uploadOrCaptureScreen__selectPassportTypeButton {
    padding-left: ${({ theme }) => theme.spacing(8)};
    padding-right: ${({ theme }) => theme.spacing(8)};
    svg {
      display: none;
    }
  }
  .uploadOrCaptureScreen__selectIdCardTypeIcon {
    path,
    rect,
    circle {
      stroke: ${({ theme }) => theme.palette.common.white};
      stroke-width: 2px;
    }
  }
  .uploadOrCaptureScreen__selectIdCardTypeButton {
    padding-left: ${({ theme }) => theme.spacing(8)};
    padding-right: ${({ theme }) => theme.spacing(8)};
    svg {
      display: none;
    }
  }
  .uploadOrCaptureScreen__selectIdTypeModalCloseButton {
    position: absolute;
    top: 0;
    right: 0;
    margin: ${({ theme }) => theme.spacing(2)};
    border-radius: 16px;
    background-color: ${({ theme }) => theme.palette.common.white};
    &:hover {
      background-color: ${({ theme }) => theme.palette.grey[200]};
    }
    svg {
      width: 20px;
      path {
        stroke: ${({ theme }) => theme.palette.grey[700]};
        stroke-width: 2px;
      }
    }
  }

  .idDocumentUploadScreen__container {
    width: 600px;
    height: auto;
    background-color: ${({ theme }) => theme.palette.common.white};
    border-radius: 16px;
    padding: ${({ theme }) => theme.spacing(4)};
    padding-bottom: 0;
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing(2)};
  }
  .idDocumentUploadScreen__actionsBar {
    border-top: none;
    padding: ${({ theme }) => `${theme.spacing(1)} 0 ${theme.spacing(3)} 0`};
    flex-grow: 1;
    button {
      flex: 1;
    }
  }
  .idDocumentUploadScreen__uploadIdFrontIcon {
    path {
      stroke: ${({ theme }) => theme.palette.common.white};
      stroke-width: 2px;
    }
  }
  .idDocumentUploadScreen__uploadIdBackIcon {
    path {
      stroke: ${({ theme }) => theme.palette.common.white};
      stroke-width: 2px;
    }
  }
  .idDocumentUploadScreen__separator {
    display: none;
  }

  .passportUploadScreen__container {
    width: 100%;
  }
  .passportUploadScreen__uploadPassportPanel {
    border-radius: 16px;
  }
  .passportUploadScreen__actionsBar {
    border-top: none;
  }
`;

export const IdmStylesMobile = styled(IdmStyles)`
  .successButtonsRow {
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing(2)};
  }
  .containerFullWidth li {
    margin-bottom: ${({ theme }) => theme.spacing(0.5)};
    line-height: 1.5;
    justify-content: flex-start;
    align-items: flex-start;
    font-size: ${({ theme }) => theme.typography.caption.fontSize};
  }

  .containerFullWidth li svg {
    margin-top: ${({ theme }) => theme.spacing(0.25)} !important;
  }
`;

export const IdmClassNames = {
  idCapture: {
    container: 'idCapture__container',
    loadingOverlay: {
      container: 'containerFullWidth',
      buttonsRow: 'containerFullWidth',
      progressBackground: 'loadingOverlay__progressBackground',
      progressBar: 'loadingOverlay__progressBar',
      continueBtn: 'idmPrimaryButton',
      heading: 'fontMedium',
    },
    capture: {
      guides: {
        guideText: 'fontMedium',
      },
    },
    success: {
      card: 'idmCardWhite',
      heading: 'fontMedium',
      buttonsRow: 'successButtonsRow',
      retryBtn: 'idmSecondaryButton',
      submitBtn: 'idmPrimaryButton',
    },
    uploadOrCaptureScreen: {
      container: 'uploadOrCaptureScreen',
      captureWithCameraPanel: 'idmCard',
      uploadFromStoragePanel: 'idmCard',
      captureWithCameraButton:
        'idmButton uploadOrCaptureScreen__captureWithCameraButton',
      captureWithCameraIcon: 'uploadOrCaptureScreen__captureWithCameraIcon',
      uploadFromStorageButton:
        'idmButton uploadOrCaptureScreen__uploadFromStorageButton',
      uploadFromStorageIcon: 'uploadOrCaptureScreen__uploadFromStorageIcon',
      separator: 'uploadOrCaptureScreen__separator',
      selectIdTypeModal: 'uploadOrCaptureScreen__selectIdTypeModal',
      selectIdTypeHeading: 'uploadOrCaptureScreen__selectIdTypeHeading',
      selectPassportTypePanel: 'idmCard',
      selectPassportTypeIcon: 'uploadOrCaptureScreen__selectPassportTypeIcon',
      selectPassportTypeButton:
        'idmButton uploadOrCaptureScreen__selectPassportTypeButton',
      selectIdCardTypePanel: 'idmCard',
      selectIdCardTypeIcon: 'uploadOrCaptureScreen__selectIdCardTypeIcon',
      selectIdCardTypeButton:
        'idmButton uploadOrCaptureScreen__selectIdCardTypeButton',
      selectIdTypeModalCloseButton:
        'uploadOrCaptureScreen__selectIdTypeModalCloseButton',
      idDocumentUploadScreen: {
        container: 'idDocumentUploadScreen__container',
        uploadIdFrontPanel: 'idmCard',
        uploadIdBackPanel: 'idmCard',
        uploadIdFrontButton: 'idmButton',
        uploadIdBackButton: 'idmButton',
        uploadIdFrontIcon: 'idDocumentUploadScreen__uploadIdFrontIcon',
        uploadIdBackIcon: 'idDocumentUploadScreen__uploadIdBackIcon',
        separator: 'idDocumentUploadScreen__separator',
        actionsBar: 'idDocumentUploadScreen__actionsBar',
        cancelButton: 'idmSecondaryButton',
        continueButton: 'idmPrimaryButton',
      },
      passportUploadScreen: {
        container: 'passportUploadScreen__container',
        uploadPassportPanel: 'passportUploadScreen__uploadPassportPanel',
        actionsBar: 'passportUploadScreen__actionsBar',
      },
    },
  },
  faceLiveness: {
    container: 'faceLiveness__container',
    loadingOverlay: {
      container: 'containerFullWidth',
      buttonsRow: 'containerFullWidth',
      progressBackground: 'loadingOverlay__progressBackground',
      progressBar: 'loadingOverlay__progressBar',
      continueBtn: 'idmPrimaryButton',
      heading: 'fontMedium',
    },
    success: {
      card: 'idmCardWhite',
      heading: 'fontMedium',
      buttonsRow: 'successButtonsRow',
      retryBtn: 'idmSecondaryButton',
      doneBtn: 'idmPrimaryButton',
    },
  },
};
